// extracted by mini-css-extract-plugin
module.exports = {"offers":"_3k0ej-","offersItem":"_1uG60f"};